module.exports = __webpack_public_path__ + "img/33.18fc2aa7.jpg";